/* eslint-disable react/jsx-props-no-spreading */
import React, { ForwardedRef } from 'react';
import { FieldError } from 'react-hook-form';

import DynamicFormError from './DynamicFormError';
import ReadOnlyText from './DynamicFormInputs/ReadOnlyText';
import YesNo from './DynamicFormInputs/YesNo';
import Checkboxes from './DynamicFormInputs/Checkboxes';
import Text from './DynamicFormInputs/Text';
import TextArea from './DynamicFormInputs/TextArea';
import Select from './DynamicFormInputs/Select';
import Photos from './DynamicFormInputs/Photos';

import { Question } from './data';

interface DynamicFormInputProps {
  name: string;
  question: Question;
  onChange: (value: any) => void;
  value?: any;
  error?: FieldError;
}

function DynamicFormInput({
  name, question, onChange, value, error,
}: DynamicFormInputProps, ref: ForwardedRef<any>) {
  return (
    <div className="dynamic-form-control">
      <ReadOnlyText
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <YesNo
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <Checkboxes
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <Text
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <TextArea
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <Select
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <Photos
        name={name}
        question={question}
        ref={ref}
        onChange={onChange}
        value={value}
      />

      <DynamicFormError error={error} label={question.label} errorMessage={question.errorMessage} />
    </div>
  );
}

export default React.forwardRef(DynamicFormInput);
